import { Directive, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';

/**
 * Measures the host element's rendered height and publishes it as the
 * `--app-header-height` CSS variable on <html>. Used by `.p-dialog-mask`
 * (and anything else that must sit below the sticky app header) so offsets
 * stay correct across browser zoom / Windows display scale changes.
 */
@Directive({
  selector: '[appHeaderHeight]',
  standalone: true
})
export class HeaderHeightDirective implements OnInit, OnDestroy {
  private hostRef = inject(ElementRef<HTMLElement>);
  private observer?: ResizeObserver;

  ngOnInit(): void {
    const el = this.hostRef.nativeElement;
    const apply = () => {
      document.documentElement.style.setProperty(
        '--app-header-height',
        `${el.getBoundingClientRect().height}px`
      );
    };
    apply();
    this.observer = new ResizeObserver(apply);
    this.observer.observe(el);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    document.documentElement.style.removeProperty('--app-header-height');
  }
}
